import { create } from "zustand"

interface SettingsSubscriptionModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
}

const useSettingsSubscriptionModalStore =
  create<SettingsSubscriptionModalStore>((set) => ({
    isOpen: false,
    onClose: () => set({ isOpen: false }),
    onOpen: () => set({ isOpen: true }),
  }))

export default useSettingsSubscriptionModalStore
